/**
 * API calls that must work for anonymous visitors (the embeddable application
 * form). Auth interceptors must never refresh tokens, sign out or reload the
 * page because of these requests.
 */
const PUBLIC_REQUEST_PATTERN =
    /api\/(users\/login|students\/(apply|public-schools))/i;

export const isPublicRequest = (url: string): boolean =>
    PUBLIC_REQUEST_PATTERN.test(url);
